import { createSlice } from '@reduxjs/toolkit';

import { CustomError } from 'shared/api';
import { getSettings } from './settingsThunk';
import { SettingsState } from './types';

const initialState: SettingsState = {
	settings: null,
	loading: false,
	error: null,
};

const settingsSlice = createSlice({
	name: 'settings',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder
			.addCase(getSettings.pending, state => {
				state.loading = true;
				state.error = null;
			})
			.addCase(getSettings.fulfilled, (state, action) => {
				state.settings = action.payload;
				state.loading = false;
			})
			.addCase(getSettings.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload as CustomError;
			});
	},
});

export const settingsReducer = settingsSlice.reducer;
